module.exports = __webpack_public_path__ + "static/media/Dr-Remy-Lombard.158c1f7e.jpg";